'use client';

import { useGetServiceTypesQuery } from '@/features/service-types/api/service-typesApi';
import { SmartInput } from '@web/ui';

type ServiceTypeSelectProps = {
  value: string;
  onChange: (value: string) => void;
  name?: string;
  label?: string;
  error?: string;
  size?: 'small' | 'medium';
  disabled?: boolean;
  includeAllOption?: boolean;
  allOptionLabel?: string;
  minWidth?: number;
  selectedLabel?: string;
  excludeIds?: readonly string[];
};

export function ServiceTypeSelect({
  value,
  onChange,
  name = 'service-type-select',
  label = '',
  error,
  size = 'small',
  disabled = false,
  includeAllOption = true,
  allOptionLabel = 'All service types',
  minWidth = 190,
  selectedLabel,
  excludeIds = [],
}: ServiceTypeSelectProps) {
  const { data } = useGetServiceTypesQuery({
    page_size: 100,
    show_archived: false,
  });

  const excludedIds = new Set(excludeIds);
  const baseOptions = (data?.data?.results ?? [])
    .filter(
      (serviceType) =>
        !excludedIds.has(serviceType.id) || serviceType.id === value,
    )
    .map((serviceType) => ({
      value: serviceType.id,
      label: serviceType.label,
    })) as Array<{ value: string; label: string }>;
  let options = includeAllOption
    ? [{ value: 'all', label: allOptionLabel }, ...baseOptions]
    : baseOptions;

  if (
    value &&
    selectedLabel &&
    !options.some((option) => option.value === value)
  ) {
    options = [...options, { value, label: selectedLabel }];
  }

  return (
    <div style={{ minWidth, width: '100%' }}>
      <SmartInput
        type="select"
        name={name}
        label={label}
        size={size}
        value={value}
        options={options}
        error={error}
        readOnly={disabled}
        onChange={(nextValue) => onChange(String(nextValue))}
      />
    </div>
  );
}
